<template>
    <div v-if="stage" class="px-4">
        <v-row>
            <v-col>
                <v-card-text class="ml-0 pa-0 ma-0">
                    <label> Ubicación a modificar: </label>
                </v-card-text>
                <RouteInBagSelectorComponent
                    v-model="stage.location_to_modify"
                    :my_bag="instances_only_bag"
                    :allow_hardcoding="false"
                    outlined></RouteInBagSelectorComponent>
            </v-col>
            <v-col>
                <v-card-text class="ml-0 pa-0 ma-0">
                    <label> Nuevo valor: </label>
                </v-card-text>
                <RouteInBagSelectorComponent
                    v-model="stage.new_value_location"
                    :my_bag="my_bag"
                    outlined></RouteInBagSelectorComponent>
            </v-col>
        </v-row>
    </div>
</template>

<script>

import { ModifyContext } from '@/modules/document/domain/WorkflowTemplate';
import { DOCS_FIELD_MAP_SHOW } from "@/modules/document/domain/Document";
import RouteInBagSelectorComponent from '@/modules/document/infra/RouteInBagSelectorComponent';
// import { get_tree_from_schema } from '@/modules/entities/domain/GetTreeFromSchema';
export default {
    name:'ModifyContextDetailComponent',
    components: {
        RouteInBagSelectorComponent,
    },
    props:{
        stage: {
            type: ModifyContext,
            default: false,
        },
        showErrors: {
            type: Boolean,
            default: false
        },
        available_types: {
            type: Array,
            default: () => []
        },
        my_bag:{
            type: Object,
            required: false,
            default: () => {}
        }
    },
    data(){
        return {
            cssLink: null,
            selected_schema: null
        }
    },
    mounted(){
        console.log(this.stage);
        // this.cssLink = document.createElement('link');
        // this.cssLink.rel = 'stylesheet';
        // this.cssLink.href = 'https://unpkg.com/json-schema-editor-vue/lib/json-schema-editor-vue.css';
        // document.head.appendChild(this.cssLink);
    },
    methods:{
        formatField(field) {
            return DOCS_FIELD_MAP_SHOW[field] || field;
        },
        
        computeStage(){
            this.$emit('compute-stage');
        },
        reset_payload(){
            console.log('reset');
            this.stage.payload_of_addresses = {};
        }
        
    },
    computed:{
        instances_only_bag(){
            let new_bag = {};
            for (let key in this.my_bag){
                if (!['documento', 'empresa'].includes(key)){
                    new_bag[key] = this.my_bag[key];
                }
            }
            return new_bag;
        },
    },
    beforeDestroy() {
        // Remove the stylesheet when the component is destroyed
        // if (this.cssLink && document.head.contains(this.cssLink)) {
        // document.head.removeChild(this.cssLink);
        // }
    }
}
</script>

<style scoped >
/*@import url('https://unpkg.com/json-schema-editor-vue@2.3.0/lib/json-schema-editor-vue.css');*/
.preaty__card {
    border-radius: 5px;
}
.small_scrollbar >>> textarea {
    scrollbar-width: thin;
}
.error--text {
    color: rgba(220, 11, 11, 0.898) !important;
}
</style>